<template>
    <Breadcrumbs main="Bonus Ui" title="Image Cropper" />
    <div class="container-fluid">
        <div class="row">
            <basicFlat />
            <shadowCard />
            <iconCard />
            <darkCard />
            <footerCard />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const basicFlat = defineAsyncComponent(() => import("@/components/theme/advance/basic/basicFlat.vue"))
const shadowCard = defineAsyncComponent(() => import("@/components/theme/advance/basic/shadowCard.vue"))
const iconCard = defineAsyncComponent(() => import("@/components/theme/advance/basic/iconCard.vue"))
const darkCard = defineAsyncComponent(() => import("@/components/theme/advance/basic/darkCard.vue"))
const footerCard = defineAsyncComponent(() => import("@/components/theme/advance/basic/footerCard.vue"))
</script>